import EventResultsSummary from "./EventResultsSummary";
export default EventResultsSummary;
